{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-410000",
  "sheetId": "StatementOfComprehensiveIncome",
  "label": "[410000] Statement of comprehensive income, net of tax (MFRS)",
  "description": "Statement of comprehensive income showing other comprehensive income items net of tax - MFRS",
  "taxonomy": "FS-MFRS",
  "controls": [
    {
      "qname": "ssmt-mfrs:ComprehensiveIncomeNetOfTaxHeader",
      "label": "Comprehensive income net of tax",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 1
      }
    },
    {
      "qname": "ssmt-mfrs:StatementOfComprehensiveIncomeNetOfTaxHeader",
      "label": "Statement of comprehensive income net of tax",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:StatementOfComprehensiveIncomeHeader",
      "label": "Statement of comprehensive income",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 3
      }
    },
    {
      "qname": "ifrs-full:ProfitLoss",
      "label": "Profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "note": "Value inherited from the Statement of Profit or Loss (Role-12) `Profit (loss)` total. Value only — `linkTo.navigate: false` keeps the row label plain text until the P.O. enables field-link navigation.",
        "linkTo": {
          "role": "310000",
          "qname": "ifrs-full:ProfitLoss",
          "navigate": false
        }
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeNetOfTaxHeader",
      "label": "Other comprehensive income/(expense), net of tax",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ifrs-full:ComponentsOfOtherComprehensiveIncomeThatWillNotBeReclassifiedToProfitOrLossNetOfTaxHeader",
      "label": "Components of other comprehensive income that will not be reclassified to profit or loss, net of tax",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeNetOfTaxGainsLossesOnRevaluation",
      "label": "Other comprehensive income, net of tax, gains (losses) on revaluation of property, plant and equipment, right-of-use assets and intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeNetOfTaxGainsLossesOnRemeasurementsOfDefinedBenefitPlans",
      "label": "Remeasurement of defined benefit liability",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeNetOfTaxGainsLossesFromInvestmentsInEquityInstruments",
      "label": "Other comprehensive income, net of tax, gains (losses) from investments in equity instruments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeNetOfTaxOtherEquityInstrumentsThatWillNotBeReclassifiedToProfitOrLoss",
      "label": "Other comprehensive income, net of tax, gains (losses) on other items",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= Revaluation + RemeasurementOfDefinedBenefit + GainsLossesFromEquityInvestments",
        "dependencies": [
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxGainsLossesOnRevaluation",
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxGainsLossesOnRemeasurementsOfDefinedBenefitPlans",
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxGainsLossesFromInvestmentsInEquityInstruments"
        ]
      }
    },
    {
      "qname": "ifrs-full:ShareOfOtherComprehensiveIncomeOfAssociatesAndJointVenturesAccountedForUsingEquityMethodThatWillNotBeReclassifiedToProfitOrLossNetOfTax",
      "label": "Share of other comprehensive income of associates and joint ventures accounted for using equity method that will not be reclassified to profit or loss, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "level": 4
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeThatWillNotBeReclassifiedToProfitOrLossNetOfTax",
      "label": "Total other comprehensive income that will not be reclassified to profit or loss, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "level": 4
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= Revaluation + RemeasurementOfDefinedBenefit + GainsLossesFromEquityInvestments + OtherItems + ShareOfOCI_NotReclassified",
        "dependencies": [
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxGainsLossesOnRevaluation",
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxGainsLossesOnRemeasurementsOfDefinedBenefitPlans",
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxGainsLossesFromInvestmentsInEquityInstruments",
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxOtherEquityInstrumentsThatWillNotBeReclassifiedToProfitOrLoss",
          "ifrs-full:ShareOfOtherComprehensiveIncomeOfAssociatesAndJointVenturesAccountedForUsingEquityMethodThatWillNotBeReclassifiedToProfitOrLossNetOfTax"
        ]
      }
    },
    {
      "qname": "ifrs-full:ComponentsOfOtherComprehensiveIncomeThatWillBeReclassifiedToProfitOrLossNetOfTaxHeader",
      "label": "Components of other comprehensive income that will be reclassified to profit or loss, net of tax",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:CashFlowHedgesHeader",
      "label": "Cash flow hedges",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 6
      }
    },
    {
      "qname": "ifrs-full:GainsLossesOnCashFlowHedgesNetOfTax",
      "label": "Gains (losses) on cash flow hedges, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ReclassificationAdjustmentsOnCashFlowHedgesNetOfTax",
      "label": "(-) Reclassification adjustments on cash flow hedges, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeNetOfTaxCashFlowHedges",
      "label": "Other comprehensive income, net of tax, cash flow hedges",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= GainsLossesOnCashFlowHedges + ReclassificationAdjustmentsOnCashFlowHedges",
        "dependencies": [
          "ifrs-full:GainsLossesOnCashFlowHedgesNetOfTax",
          "ifrs-full:ReclassificationAdjustmentsOnCashFlowHedgesNetOfTax"
        ]
      }
    },
    {
      "qname": "ifrs-full:HedgesOfNetInvestmentsInForeignOperationsHeader",
      "label": "Hedges of net investment in foreign operations",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 6
      }
    },
    {
      "qname": "ifrs-full:GainsLossesOnHedgesOfNetInvestmentsInForeignOperationsNetOfTax",
      "label": "Gains (losses) on hedges of net investments in foreign operations, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ReclassificationAdjustmentsOnHedgesOfNetInvestmentsInForeignOperationsNetOfTax",
      "label": "(-) Reclassification adjustments on hedges of net investments in foreign operations, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeNetOfTaxHedgesOfNetInvestmentsInForeignOperations",
      "label": "Other comprehensive income, net of tax, hedges of net investments in foreign operations",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= GainsLossesOnHedgesOfNetInvestments + ReclassificationAdjustmentsOnHedgesOfNetInvestments",
        "dependencies": [
          "ifrs-full:GainsLossesOnHedgesOfNetInvestmentsInForeignOperationsNetOfTax",
          "ifrs-full:ReclassificationAdjustmentsOnHedgesOfNetInvestmentsInForeignOperationsNetOfTax"
        ]
      }
    },
    {
      "qname": "ifrs-full:ExchangeDifferencesOnTranslationHeader",
      "label": "Exchange differences on translation",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 6
      }
    },
    {
      "qname": "ifrs-full:GainsLossesOnExchangeDifferencesOnTranslationNetOfTax",
      "label": "Gains (losses) on exchange differences on translation, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ReclassificationAdjustmentsOnExchangeDifferencesOnTranslationNetOfTax",
      "label": "(-) Reclassification adjustments on exchange differences on translation, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeNetOfTaxExchangeDifferencesOnTranslation",
      "label": "Other comprehensive income, net of tax, exchange differences on translation",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= GainsLossesOnExchangeDifferences + ReclassificationAdjustmentsOnExchangeDifferences",
        "dependencies": [
          "ifrs-full:GainsLossesOnExchangeDifferencesOnTranslationNetOfTax",
          "ifrs-full:ReclassificationAdjustmentsOnExchangeDifferencesOnTranslationNetOfTax"
        ]
      }
    },
    {
      "qname": "ifrs-full:FinancialAssetsMeasuredAtFairValueThroughOtherComprehensiveIncomeHeader",
      "label": "Financial assets measured at fair value through other comprehensive income",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 6
      }
    },
    {
      "qname": "ifrs-full:GainsLossesOnFinancialAssetsMeasuredAtFairValueThroughOtherComprehensiveIncomeNetOfTax",
      "label": "Gains (losses) on financial assets measured at fair value through other comprehensive income, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:ReclassificationAdjustmentsOnFinancialAssetsMeasuredAtFairValueThroughOtherComprehensiveIncomeNetOfTax",
      "label": "(-) Reclassification adjustments on financial assets measured at fair value through other comprehensive income, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:AmountsRemovedFromEquityAndAdjustedAgainstFairValueOfFinancialAssetsOnReclassificationOutOfFairValueThroughOtherComprehensiveIncomeMeasurementCategoryNetOfTax",
      "label": "(-) Amounts removed from equity and adjusted against fair value of financial assets on reclassification out of fair value through other comprehensive income measurement category, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeNetOfTaxFinancialAssetsMeasuredAtFairValueThroughOtherComprehensiveIncome",
      "label": "Other comprehensive income, net of tax, financial assets measured at fair value through other comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= GainsLossesOnFVOCI + ReclassificationAdjustmentsOnFVOCI + AmountsRemovedFromEquityOnReclassification",
        "dependencies": [
          "ifrs-full:GainsLossesOnFinancialAssetsMeasuredAtFairValueThroughOtherComprehensiveIncomeNetOfTax",
          "ifrs-full:ReclassificationAdjustmentsOnFinancialAssetsMeasuredAtFairValueThroughOtherComprehensiveIncomeNetOfTax",
          "ifrs-full:AmountsRemovedFromEquityAndAdjustedAgainstFairValueOfFinancialAssetsOnReclassificationOutOfFairValueThroughOtherComprehensiveIncomeMeasurementCategoryNetOfTax"
        ]
      }
    },
    {
      "qname": "ifrs-full:ShareOfOtherComprehensiveIncomeOfAssociatesAndJointVenturesAccountedForUsingEquityMethodThatWillBeReclassifiedToProfitOrLossNetOfTax",
      "label": "Share of other comprehensive income of associates and joint ventures accounted for using equity method that will be reclassified to profit or loss, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "level": 5
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ssmt-mfrs:OtherComprehensiveIncomeNetOfTaxGainsLossesOnOtherItems",
      "label": "Others comprehensive income, net of tax, gains (losses) on other items",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "level": 5
      },
      "validation": {
        "dataType": "decimal"
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncomeThatWillBeReclassifiedToProfitOrLossNetOfTax",
      "label": "Total other comprehensive income that will be reclassified to profit or loss, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "level": 5
      },
      "validation": {
        "dataType": "decimal"
      },
      "calculation": {
        "formula": "= CashFlowHedges + HedgesOfNetInvestments + ExchangeDifferences + FVOCI + ShareOfOCI_WillBeReclassified + OtherItems",
        "dependencies": [
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxCashFlowHedges",
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxHedgesOfNetInvestmentsInForeignOperations",
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxExchangeDifferencesOnTranslation",
          "ifrs-full:OtherComprehensiveIncomeNetOfTaxFinancialAssetsMeasuredAtFairValueThroughOtherComprehensiveIncome",
          "ifrs-full:ShareOfOtherComprehensiveIncomeOfAssociatesAndJointVenturesAccountedForUsingEquityMethodThatWillBeReclassifiedToProfitOrLossNetOfTax",
          "ssmt-mfrs:OtherComprehensiveIncomeNetOfTaxGainsLossesOnOtherItems"
        ]
      }
    },
    {
      "qname": "ifrs-full:OtherComprehensiveIncome",
      "required": true,
      "label": "Total other comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "level": 4
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfChangesInEquity",
            "field": "ifrs-full:OtherComprehensiveIncome"
          }
        ]
      },
      "calculation": {
        "formula": "= TotalNotReclassified + TotalWillBeReclassified",
        "dependencies": [
          "ifrs-full:OtherComprehensiveIncomeThatWillNotBeReclassifiedToProfitOrLossNetOfTax",
          "ifrs-full:OtherComprehensiveIncomeThatWillBeReclassifiedToProfitOrLossNetOfTax"
        ]
      }
    },
    {
      "qname": "ifrs-full:ComprehensiveIncome",
      "required": true,
      "label": "Total comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "level": 4
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfComprehensiveIncome",
            "field": "ifrs-full:ComprehensiveIncome_2"
          },
          {
            "sheet": "statementOfChangesInEquity",
            "field": "ifrs-full:ComprehensiveIncome"
          }
        ]
      },
      "calculation": {
        "formula": "= ProfitLoss + TotalOtherComprehensiveIncome",
        "dependencies": [
          "ifrs-full:ProfitLoss",
          "ifrs-full:OtherComprehensiveIncome"
        ]
      }
    },
    {
      "qname": "ifrs-full:ComprehensiveIncomeAttributableToHeader",
      "label": "Comprehensive income attributable to",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 5
      }
    },
    {
      "qname": "ifrs-full:ComprehensiveIncomeAttributableToOwnersOfParent",
      "label": "Comprehensive income, attributable to owners of parent",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "requiredIf": {
        "sheet": "filingPrerequisites",
        "field": "ssmt-dei-ee-mfrs:NatureOfFinancialStatements",
        "equals": "Consolidated",
        "errorMessage": "When \"Nature of Financial Statements\" is \"Consolidated\", then \"Comprehensive income, attributable to owners of parent\" MUST be reported."
      }
    },
    {
      "qname": "ifrs-full:ComprehensiveIncomeAttributableToNoncontrollingInterests",
      "label": "Comprehensive income, attributable to non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true
      },
      "validation": {
        "dataType": "decimal"
      },
      "requiredIf": {
        "sheet": "filingPrerequisites",
        "field": "ssmt-dei-ee-mfrs:NatureOfFinancialStatements",
        "equals": "Consolidated",
        "errorMessage": "When \"Nature of Financial Statements\" is \"Consolidated\", then \"Comprehensive income, attributable to non-controlling interests\" MUST be reported."
      }
    },
    {
      "qname": "ifrs-full:ComprehensiveIncome_2",
      "required": true,
      "label": "Total comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfComprehensiveIncome",
            "field": "ifrs-full:ComprehensiveIncome"
          }
        ]
      },
      "calculation": {
        "formula": "= AttributableToOwners + AttributableToNCI",
        "dependencies": [
          "ifrs-full:ComprehensiveIncomeAttributableToOwnersOfParent",
          "ifrs-full:ComprehensiveIncomeAttributableToNoncontrollingInterests"
        ]
      }
    }
  ]
}
